import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC } from 'react';

type VolumeOffProps = {
    className?: string;
};

const VolumeOff: FC<VolumeOffProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'volume-off'}
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
        >
            <path d="M0 81v88h70l88.4 45.7V35.3L70 81H0zm149.4-31v150l-75.3-39c-1.3-.7-2.7-1-4.1-1H9V90h61c1.4 0 2.9-.3 4.1-1l75.3-39z" />
            <polygon points="250,98.7 243.6,92.4 217.4,118.6 191.1,92.4 184.8,98.7 211,125 184.8,151.3 191.1,157.6 217.4,131.4 243.6,157.6 250,151.3 223.7,125" />
        </svg>
    );
};

export default VolumeOff;
